import CampaignPage from "../components/CampaignPage";

const campaignRoutes = [
    {
        path: '/',
        component: CampaignPage
    }
]
export default campaignRoutes;